import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { DealerFeature } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';
import { SubNavLegalComponent } from '../sub-nav-legal/sub-nav-legal.component';

@Component({
    selector: 'app-legal-notices-page',
    standalone: true,
    imports: [SubNavLegalComponent],
    templateUrl: './legal-notices-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticesPageComponent {
    protected readonly store = inject(Store);

    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerName = this.store.selectSignal(DealerFeature.state.selectDealerName);
}
